import { Shop, Sneaker } from "@/types/types";
import { create } from "zustand";

interface State {
  data: Sneaker[];
  colors: Record<string, boolean>;
  setColors: (colors: Record<string, boolean>) => void;
  brands: Record<string, boolean>;
  setBrands: (brands: Record<string, boolean>) => void;
  sizes: Record<string, boolean>;
  setSizes: (sizes: Record<string, boolean>) => void;
  searchResults: Sneaker[];
  sneaker: Sneaker;
  setSneaker: (sneaker: State["sneaker"]) => void;
  shops: Shop[];
  setShops: (shops: State["shops"]) => void;
  priceMin: number | undefined;
  priceMax: number | undefined;
  setpriceMin: (priceMin: number | undefined) => void;
  setpriceMax: (priceMax: number | undefined) => void;

  isActiveFilter: boolean;
  isModalOpen: boolean;
  showMoreNumber: number;

  setShowMoreNumber: () => void;
  setIsActiveFilter: () => void;

  setIsModalOpen: () => void;

  setData: (data: Sneaker[] | undefined) => void;
  numsFound: number;
  setNumsFound: (numsFound: number) => void;

  selectorFilter: string | null;
  setSelectorFilter: (selectorFilter: string | null) => void;
  sizeCopy: string;
  setSizeCopy: (sizeCopy: string) => void;
  search: string;
  setSearch: (search: string) => void;
  resetFilters: () => void;
}

export const useStore = create<State>()((set) => ({
  numsFound: 0,
  data: [],

  sneaker: {} as Sneaker,
  setSneaker: (sneaker) => set(() => ({ sneaker: sneaker })),

  sizes: {},
  setSizes: (sizes: Record<string, boolean>) => set(() => ({ sizes })),

  colors: {},
  setColors: (colors: Record<string, boolean>) =>
    set(() => ({ colors: colors })),

  brands: {},
  setBrands: (brands: Record<string, boolean>) =>
    set(() => ({ brands: brands })),

  priceMin: undefined,
  setpriceMin: (priceMin: number | undefined) => set(() => ({ priceMin })),

  priceMax: undefined,
  setpriceMax: (priceMax: number | undefined) => set(() => ({ priceMax })),

  search: "",
  setSearch: (search: string) => set(() => ({ search })),

  shops: [],
  setShops: (shops) => set(() => ({ shops: shops })),

  setNumsFound: (numsFound: number) => set(() => ({ numsFound })),
  showMoreNumber: 10,
  setShowMoreNumber: () =>
    set((state) => ({ showMoreNumber: state.showMoreNumber + 10 })),
  setData: (data: Sneaker[] | undefined) => set(() => ({ data: data })),
  searchResults: [],

  selectorFilter: "",
  setSelectorFilter: (selectorFilter: string | null) =>
    set(() => ({ selectorFilter })),

  isActiveFilter: false,
  setIsActiveFilter: () =>
    set((state) => ({ isActiveFilter: !state.isActiveFilter })),

  sizeCopy: "",
  setSizeCopy: (sizeCopy: string) => set(() => ({ sizeCopy: sizeCopy })),

  isModalOpen: false,
  setIsModalOpen: () => set((state) => ({ isModalOpen: !state.isModalOpen })),

  resetFilters: () =>
    set(() => ({
      colors: {},
      brands: {},
      sizes: {},
      showMoreNumber: 10,

      priceMin: undefined,
      priceMax: undefined,
    })),
}));
